var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newValue),expression:"newValue"}],class:[
        'ui-inputtext', 'ui-corner-all', 'ui-state-default', 'ui-widget', {
        'ui-state-filled': _vm.filled
       }],domProps:{"value":(_vm.newValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newValue=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37130d41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputtext/inputtext.vue
// module id = 7k/h
// module chunks = 0